import {EventBus} from "../../../../../../common/ts/events/EventBus";
import {
    AlertSuggestionsReceivedEvent, EmptyEvent,
    SaveEmailAlertRequestedEvent,
    ShowRetentionCaptureModalRequestedEvent, ShowRetentionPopupMobileRequestedEvent
} from "./events";
import {FullPageModalOpenEvent, WhitelabelEvent} from "../../../../../../common/ts/events/Events";
import {EMAIL_RETENTION_POPUP_MOBILE, EMAIL_RETENTION_POPUP_MOBILE_FORM, SAVE_SEARCH_MODAL} from "./constants";
import dom, {PopulateFormEvent, SetAdjacentHTMLEvent, ShowEvent} from "../../../../../../common/ts/core/dom";
import apiClassic from "../../../../apiClassic";
import http from "../../../../../../common/ts/core/http";

let eventBus: EventBus;

export function saveEmailAlertRequestedEventHandler(event: WhitelabelEvent) {
    const { payload: {searches, email, wantNews, successEvent } } = event as SaveEmailAlertRequestedEvent;
    eventBus.emit(apiClassic.events.createMultipleEmailAlerts({searches, email, wantNews, successEvent}));
}

export function showRetentionPopupMobileRequestedEventHandler() {
    eventBus.emit(new PopulateFormEvent({
        selector: EMAIL_RETENTION_POPUP_MOBILE_FORM,
        data: [["email", localStorage.getItem("email")]],
    }));

    eventBus.emit(new ShowEvent({ selector: EMAIL_RETENTION_POPUP_MOBILE }));
}

export function showRetentionCaptureModalRequestedEventHandler(event: WhitelabelEvent) {
    eventBus.emit(new PopulateFormEvent({
        selector: "#js-email-retention-form",
        data: [['email', localStorage.getItem("email")]],
    }))

    const { payload: { search, hasPreviousSuggestions } } = event as ShowRetentionCaptureModalRequestedEvent;
    if (!hasPreviousSuggestions) {
        getSuggestions(search)
    }

    eventBus.emit(new FullPageModalOpenEvent({
        id: SAVE_SEARCH_MODAL,
    }));
}

export function alertSuggestionsReceivedEventHandler(event: WhitelabelEvent) {
    const { payload: { response: suggestions }} = event as AlertSuggestionsReceivedEvent;
    for (let i = 0; i < suggestions.length; i++) {
        const suggestion = suggestions[i];
        eventBus.emit(new SetAdjacentHTMLEvent({
            selector: "#email-retention-form__suggestions__inputs",
            html: dom.getSuggestionTemplate(suggestion) })
        )
    }

    const hasSuggestions = suggestions && suggestions.length > 0;
    if (hasSuggestions) {
        eventBus.emit(new dom.ShowEvent({
            selector: "#email-retention-form__suggestions",
        }));
    }
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(SaveEmailAlertRequestedEvent.TYPE, saveEmailAlertRequestedEventHandler);
    eventBus.subscribe(AlertSuggestionsReceivedEvent.TYPE, alertSuggestionsReceivedEventHandler);
    eventBus.subscribe(ShowRetentionCaptureModalRequestedEvent.TYPE, showRetentionCaptureModalRequestedEventHandler);
    eventBus.subscribe(ShowRetentionPopupMobileRequestedEvent.TYPE, showRetentionPopupMobileRequestedEventHandler);
}

function getSuggestions(search: string) {
    const keyword = search.replace(" ", "-").toLowerCase()
    eventBus.emit(new http.GetEvent({
        url: `/api/alerts/suggestions/${keyword}`,
        successEvent: { eventClass: AlertSuggestionsReceivedEvent },
        errorEvent: { eventClass: EmptyEvent }
    }))
}

export default {
    init,
};
